import { type FC, type ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Col, Form, Popover, Row } from 'antd';
import type { TooltipPlacement } from 'antd/es/tooltip';

import { routeFileSelector } from '../../../../../../utilz/i18n';
import Button from '../../../../../components/Buttons/Button';
import FormInput from '../../../../../components/Inputs/FormInput';
import FormSelectBox from '../../../../../components/Inputs/FormSelectBox';
import FormLabel from '../../../../../components/Labels/FormLabel';

export type AccessorialFilterData = {
  filterType: string;
  searchValue: string;
};

interface AccessorialsFilterPopOverProps {
  children: ReactNode;
  open: boolean;
  setOpen: (value: boolean) => void;
  handleFilter: (value: AccessorialFilterData) => void;
  placement?: TooltipPlacement;
}

const AccessorialsFilterPopOver: FC<AccessorialsFilterPopOverProps> = ({
  children,
  open,
  setOpen,
  handleFilter,
  placement,
}) => {
  const [form] = Form.useForm();
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  return (
    <Popover
      onOpenChange={(val) => setOpen(val)}
      open={open}
      overlayClassName="common-popover"
      content={
        <div className="p-15">
          <FormLabel className="f-14 mb-15 white-space-nowrap">
            {`${t('translation:shipmentAdd.accountingDetails.showItem')} :`}
          </FormLabel>
          <Form form={form} initialValues={{ filterType: 'START', searchValue: '' }} onFinish={handleFilter}>
            <FormSelectBox
              options={[
                { label: t('translation:shipmentAdd.accountingDetails.startWith'), value: 'START' },
                { label: t('translation:shipmentAdd.accountingDetails.isEqualTo'), value: 'EQUAL' },
              ]}
              margin="my-15"
              name="filterType"
            />
            <FormInput
              placeholder={`${t('translation:default.buttons.search')}...`}
              margin="m-0"
              editMode
              name="searchValue"
            />
            <Row className="mt-15" gutter={15}>
              <Col sm={12}>
                <Button className="w-100" buttonType="submit">
                  {t('translation:default.fields.filter')}
                </Button>
              </Col>
              <Col sm={12}>
                <Button
                  className="w-100"
                  onClick={() => {
                    form.resetFields();
                    handleFilter({ filterType: 'START', searchValue: '' });
                  }}
                >
                  {t('translation:default.fields.reset')}
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      }
      title={false}
      trigger="click"
      {...(placement ? { placement } : {})}
    >
      {children}
    </Popover>
  );
};

export default AccessorialsFilterPopOver;
